import { IMonitoringService } from "./types";

export class ConsoleMonitoringService implements IMonitoringService {
  captureMessage(message: string, extra?: Record<string, any>): void {
    console.warn("Monitoring Message:", message, extra ? { extra } : "");
  }

  captureException(error: Error | unknown, extra?: Record<string, any>): void {
    console.error("Monitoring Exception:", error, extra ? { extra } : "");
  }
}